module.exports = __webpack_public_path__ + "img/landing.82ea2e03.svg";